import enviro from 'enviro';

export const consoleIfNotProd = {
  log: (...args: unknown[]) => {
    if (!enviro.isProd()) {
      console.log(...args);
    }
  },
  warn: (...args: unknown[]) => {
    if (!enviro.isProd()) {
      console.warn(...args);
    }
  },
  error: (...args: unknown[]) => {
    if (!enviro.isProd()) {
      console.error(...args);
    }
  },
};
